import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar, Menu, MenuItem } from 'mw-style-react';
import { LOGOUT } from 'constants';
import useIntl from 'useIntl';
import mes from './intl';
import './UserProfile.scss';

function UserProfile() {
  const t = useIntl();
  const [profileMenu, toggleProfileMenu] = useState(false);
  const config = useSelector((state) => state.config);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const handleProfileMenuClick = ({ value }) => {
    if (value === 'logout') {
      dispatch({ type: LOGOUT.REQUEST });
    } else if (value === 'profile') {
      const profileUrl = config.saUrl
        ? `${config.saUrl}/profile`
        : 'https://account.corezoid.com/profile';
      window.open(profileUrl);
    }
  };

  return (
    <div styleName="profile">
      <div styleName="profile__avatar__box">
        <Avatar
          styleName="profile__avatar"
          src={auth.avatar}
          label={auth.nick}
          onClick={() => toggleProfileMenu(!profileMenu)}
        />
      </div>
      <div styleName="profile__menu">
        <Menu
          onClick={handleProfileMenuClick}
          onClose={() => toggleProfileMenu(false)}
          visibility={profileMenu ? 'visible' : 'hidden'}
        >
          <MenuItem value="profile" label={t(mes.profile)} />
          <MenuItem value="logout" label={t(mes.logout)} />
        </Menu>
      </div>
    </div>
  );
}

export default UserProfile;
